import * as actionTypes from '../../store/actions/ActionTypes';
import baseService from '../BaseService';
import Config from '../../utils/Configuration';

const getHeaderFooterInfo = () => {
    return fetch(`${Config.apiConfig.aemEndPoint}/bin/global/headerfooter.json`).then((res) => res.json());
};

const getHeaderFooterSuccess = (res) => {
    return res || {};
};

export const getHeaderFooter = () => {
    return async (dispatch) => {
        return baseService.serviceRequest({}, dispatch, getHeaderFooterInfo, {}, actionTypes.GET_HEADER_FOOTER, (res) =>
            getHeaderFooterSuccess(res)
        );
    };
};
